<template>
  <div id="videos">
    <div class="wrap">
      <popups text="视频教学" submit="hide" @onOff="$emit('onOff', 'videos')">
        <div class="video-tab">
          <div class="prev" @click="prev"></div>
          <div class="video-list">
            <transition name="tab">
              <div class="video-item" v-if="count === item.id" v-for="item in list" :key="item.id">
                <div class="title">{{ item.text }}</div>
                <div class="video-content" :class="[item.bg]" v-if="item.isOpenVideo" @click="openVideo(item.id)"></div>
                <div class="video-content" v-else>
                  <iframe height=466 width=826 :src='item.link' frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" allowtransparency="true"></iframe>
                </div>
              </div>
            </transition>
          </div>
          <div class="next" @click="next"></div>
        </div>
        <div class="tab-list">
          <div class="tab-item" v-for="item in list" :key="item.id" :class="[item.id === count ? 'tab-active' : '']"></div>
        </div>
      </popups>
    </div>
  </div>
</template>

<script>
import popups from '../popups/popups'

export default {
  name: 'videos',
  data () {
    return {
      count: 0,
      list: [
        {id: 0, text: '任务目标系统 OKR', bg: 'okr', isOpenVideo: true, link: 'https://player.youku.com/embed/XMzE2MzQyMzYyMA=='},
        {id: 1, text: '客户渠道管理 CRM', bg: 'crm', isOpenVideo: true, link: 'https://player.youku.com/embed/XNDQzMzI5MDc4NA=='},
        {id: 2, text: '绩效考核', bg: 'performance', isOpenVideo: true, link: 'https://player.youku.com/embed/XMzE1OTM0MDI3Mg=='},
        {id: 3, text: '审批系统', bg: 'approval', isOpenVideo: true, link: 'https://player.youku.com/embed/XNDQ1NTA4NDAzMg=='},
        {id: 4, text: '考勤系统', bg: 'attendance', isOpenVideo: true, link: 'https://player.youku.com/embed/XNDQ4MjA3MDgxNg=='}
      ]
    }
  },
  components: {
    popups
  },
  methods: {
    prev () {
      if (this.count === 0) {
        this.count = this.list.length - 1
      } else {
        this.count -= 1
      }
    },
    next () {
      if (this.count >= this.list.length - 1) {
        this.count = 0
      } else {
        this.count += 1
      }
    },
    openVideo (id) {
      this.list.forEach(item => {
        if (item.id === id) {
          item.isOpenVideo = false
        } else {
          item.isOpenVideo = true
        }
      })
    }
  }
}
</script>

<style scoped>
  @keyframes show {
    0% {
      opacity: 0;
      left: 826px;
    }
    100% {
      opacity: 1;
      left: 0;
    }
  }
  @keyframes hide {
    0% {
      opacity: 1;
      left: 0;
    }
    100% {
      opacity: 0;
      left: -826px;
    }
  }
  .tab-enter-active {
    animation: show 1.2s;
  }
  .tab-leave-active {
    animation: hide 1.2s;
  }
  .tab-enter, .tab-leave-to {
    opacity: 0;
  }

  #videos {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .wrap {
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1000;
    transform: translate(-50%, -50%);
    width: 1078px;
    height: 715px;
    padding: 38px 40px 46px 41px;
    background: #fff;
  }

  .video-tab {
    display: flex;
    justify-content: space-between;
  }

  .prev, .next {
    width: 34px;
    height: 70px;
    background: red;
    transform: translate(0, 291px);
    cursor: pointer;
  }

  .prev {
    background: url("../../icons/prev-video.svg") no-repeat;
    transform: translate(-8px, 291px);
  }

  .next {
    background: url("../../icons/next-video.svg") no-repeat;
    transform: translate(8px, 291px);
  }

  .video-list {
    position: relative;
    width: 826px;
    height: 561px;
    overflow: hidden;
  }

  .video-item {
    position: absolute;
  }

  .title {
    width: 100%;
    height: 36px;
    margin: 36px auto 23px;
    font-size: 25px;
    color: rgba(0,0,0,0.87);
    text-align: center;
    line-height: 36px;
    letter-spacing: 0;
  }

  .video-content {
    box-sizing: border-box;
    width: 826px;
    height: 466px;
    cursor: pointer;
  }
  .video-content video {
    width: 826px;
    height: 466px;
    border-radius: 12px;
  }
  .okr {
    background: url("../../icons/play.svg") no-repeat center center, url("../../icons/image/task.png") no-repeat;
  }
  .crm {
    background: url("../../icons/play.svg") no-repeat center center, url("../../icons/image/crm.png") no-repeat;
  }
  .performance {
    background: url("../../icons/play.svg") no-repeat center center, url("../../icons/image/performance.png") no-repeat;
  }
  .approval {
    background: url("../../icons/play.svg") no-repeat center center, url("../../icons/image/approval.png") no-repeat;
  }
  .attendance {
    background: url("../../icons/play.svg") no-repeat center center, url("../../icons/image/attendance.png") no-repeat;
  }

  .tab-list {
    width: 100%;
    margin-top: 45px;
    font-size: 0;
    text-align: center;
  }

  .tab-item {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 12.5px;
    border-radius: 50%;
    background: #D8D8D8;
  }
  .tab-active {
    background: #4A90E2;
  }
</style>



// WEBPACK FOOTER //
// src/components/videos/videos.vue